import React from "react";
import '../styles/style.css';

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
      <div className="navbar-header">
        <button
          type="button"
          className="navbar-toggle collapsed"
          data-toggle="collapse"
          data-target="#bs-example-navbar-collapse-1"
        >
          <span className="sr-only">Toggle navigation</span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </button>
        <a className="brand page-scroll" href="/">
        <img className="redeemer-navbar-logo" src='img/redeemer-technologies-logo.svg' 
                     width="50" height="50" 
                     alt="Redeemer Technologies Pvt Ltd" />
        </a>
      </div>


        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            
            <li>
              <a href="/#about" className="page-scroll">
                About
              </a>
            </li>
            <li>
              <a href="/#services" className="page-scroll">
                Services
              </a>
            </li>
            <li>
              <a href="https://careers.redeemertechnologies.com/" className="page-scroll">
                Careers
              </a>
            </li>
            
            <li>
              <a href="/#contact" className="page-scroll">
                Contact
              </a>
            </li>
            <li>
              <a href="/biocalculus" className="page-scroll">
              Biocalculus
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
